module.exports = __webpack_public_path__ + "static/media/PayBy Pay.4df1c633.svg";